import type { ConfigResponse } from '@avocado-solana/shared';
import { env } from '@/lib/env';

let cachedConfig: { fetchedAt: number; config: ConfigResponse } | null = null;
const CONFIG_TTL_MS = 60_000;

export async function getConfig(force = false): Promise<ConfigResponse> {
  if (!force && cachedConfig && Date.now() - cachedConfig.fetchedAt < CONFIG_TTL_MS) {
    return cachedConfig.config;
  }
  const res = await fetch(env.apiBase.replace(/\/$/, '') + '/config');
  if (!res.ok) {
    throw new Error(`/config failed: ${res.status}`);
  }
  const config = (await res.json()) as ConfigResponse;
  cachedConfig = { fetchedAt: Date.now(), config };
  return config;
}

export function clearConfigCache(): void {
  cachedConfig = null;
}
